import React, { Fragment, useState } from "react";
import { Toaster } from "react-hot-toast";

import Card from "../commons/Card";

import TrainingCourseSearchField from "./components/TrainingCourseSearchField";
import NewTrainingCourseButton from "./components/NewTrainingCourseButton";
import TrainingCourseSelector from "./components/TrainingCourseSelector";
import TrainingCourseViewer from "./components/TrainingCourseViewer";

const TrainingCourses = ({ data }) => {

  const { training_courses, selected_course } = data || {};

  const [courses, setCourses] = useState(training_courses);
  const [selectedCourse, setSelectedCourse] = useState(selected_course);

  const handleSearchResultsReturned = (courses) => {
    setCourses(courses);

    const found = courses?.find(c => c.uuid === selected_course.uuid);
    if (!found && courses?.length) setSelectedCourse(courses[0]);
  }

  const renderHeader = () => (
    <div className="training-courses-row header">
      {courses?.length ? (
        <TrainingCourseSearchField
          onResults={handleSearchResultsReturned}
          onCancel={() => handleSearchResultsReturned(training_courses)}
        />
      ) : null}
      <NewTrainingCourseButton />
    </div>
  );

  const renderContent = () => (
    <div className="training-courses-row content">
      <div className="side-panel">
        <TrainingCourseSelector
          courses={courses}
          selectedCourse={selectedCourse}
        />
      </div>
      <div className="primary-panel">
        <TrainingCourseViewer course={selectedCourse} />
      </div>
    </div>
  );

  const renderEmptyState = () => (
    <div className="empty-state">
      <Card content={I18n.t("training_courses.empty")} />
    </div>
  );

  return (
    <Fragment>
      <div className="training-courses">
        <div className="container-fluid">
          {renderHeader()}
          {courses?.length ? renderContent() : renderEmptyState()}
        </div>
      </div>
      <Toaster
        position="top-right"
        reverseOrder
      />
    </Fragment>
  );
}

export default TrainingCourses;
